import React, { useState } from "react";
import axios from "axios";
import { TextField, Button, Typography, Paper } from "@mui/material";

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");   // 🔑 mot de passe au lieu de téléphone
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API}/admin/login`, {
        email,
        password   // 🔑 envoie email + password
      });

      const { token } = res.data;
      localStorage.setItem("adminToken", token);
      onLogin(); // redirige vers le dashboard
    } catch (err) {
      setError("Accès refusé ou identifiants incorrects.");
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 400, margin: "auto", mt: 5 }}>
      <Typography variant="h5" gutterBottom>Connexion Admin</Typography>
      
      <TextField
        label="Email"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      
      <TextField
        label="Mot de passe"
        type="password"   // 🔑 champ sécurisé
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      
      {error && <Typography color="error">{error}</Typography>}
      
      <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleSubmit}>
        Se connecter
      </Button>
    </Paper>
  );
};

export default AdminLogin;
